import React, { useState } from "react";

import dayjs from "dayjs";
import { Plus, Edit } from "icons";
import Pluralize from "pluralize";

import { Button, Typography } from "clearsense-ui/components";

import AddNewValue from "./AddNewValue";

const CreateValues = ({ values, setValues }) => {
  const [addNewValue, setAddNewValue] = useState(false);
  const [editedValue, setEditedValue] = useState(-1);

  return (
    <div className="mb-14 w-full">
      <Typography style="condensedMedium" className="mb-8 text-gray-500">
        This Reference Source has
        {values.length === 0
          ? " no values yet."
          : ` ${Pluralize("value", values.length, true)}.`}
      </Typography>

      {values.map((value, index) =>
        editedValue === index ? (
          <AddNewValue
            setVisible={setEditedValue}
            position={index}
            setValues={setValues}
            values={values}
          />
        ) : (
          <div
            key={index}
            className="bg-gray-50 flex justify-between items-center border border-solid border-gray-300 w-full p-4 mb-2"
          >
            <Typography type="bold">{value.name}</Typography>
            <div className="flex items-center gap-10">
              <Typography className="text-gray-500">
                (Start Date: {dayjs(value.start_date).format("MMMM DD, YYYY")})
              </Typography>
              <Button
                style="text"
                icon={() => <Edit size="20" />}
                onClick={() => setEditedValue(index)}
              />
            </div>
          </div>
        )
      )}

      {addNewValue && (
        <AddNewValue setValues={setValues} setVisible={setAddNewValue} />
      )}
      <Button
        label="Add Value"
        icon={Plus}
        className="mt-4"
        disabled={addNewValue}
        onClick={() => setAddNewValue(true)}
      />
    </div>
  );
};

export default CreateValues;
